import type { ParsedZplLabel } from '@wms/domain';
import { useEffect, useMemo, useState } from 'react';
import { labelSvg, loadZplLabels } from '../zpl/render';

/** One label drawn as it prints (an image of the SVG: nothing in it can run). */
export function ZplLabelView({ label }: { label: ParsedZplLabel }) {
  const src = useMemo(() => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(labelSvg(label))}`, [label]);
  return <img className="zpl-label" src={src} alt="Etiket önizlemesi" />;
}

/** The labels of a ZPL document, logos and all, with what could only be drawn approximately. */
export function ZplPreview({ zpl }: { zpl: string }) {
  const [labels, setLabels] = useState<readonly ParsedZplLabel[] | null>(null);
  useEffect(() => {
    let alive = true;
    void loadZplLabels(zpl).then((l) => alive && setLabels(l));
    return () => {
      alive = false;
    };
  }, [zpl]);
  if (!labels) return null;
  const warnings = [...new Set(labels.flatMap((l) => l.warnings))];
  return (
    <div className="stack">
      {warnings.length > 0 && (
        <div className="banner warn" style={{ fontSize: 13 }}>
          <div>
            Etiketin bazı parçaları yaklaşık çiziliyor: {warnings.join(' · ')}. Yazıcı ZPL destekliyorsa ağ yazıcısı veya yazdırma ajanı birebir basar.
          </div>
        </div>
      )}
      <div className="zpl-sheet">
        {labels.map((label, i) => (
          <ZplLabelView key={i} label={label} />
        ))}
      </div>
    </div>
  );
}
